import React, { useState, useContext } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { SEARCH, SearchContext } from '../search/SearchContext'
import Rating from '../common/Rating'
import HotelTags from '../../common/hotels/HotelTags'
import { MHotel } from '../types'
// import { getRecheckHotelRates } from '../api/hotel'
import { isNotPriceApplicableUser, userTypeSupportsSurcharge } from '../helpers/userHelper'
//import { recheckHotelRates } from '../helpers/hotelHelper'
import HotelImage from './HotelImage'
import { fetchRatesForHotel } from '../helpers/hotelHelper'
import { canViewNonRefundableRates } from '../helpers/userHelper'

const HotelItem = ({ hotel }) => {
  const { state, dispatch } = useContext(SearchContext)
  const _setHotelHover = payload => dispatch({ type: SEARCH.HOVERED_HOTEL.SET, payload: payload})
  const [showFeeInfo, setShowFeeInfo] = useState(false)

  const _clickHandler = async (hotel) => {
    dispatch({ type: SEARCH.HOTEL.SET, payload: hotel })
    dispatch({ type: SEARCH.ROOM.SET, payload: hotel.room_rates.rooms[0] })
    dispatch({ type: SEARCH.POP_UP_OPEN.SET, payload: true })

    if (canViewNonRefundableRates(state.user) && hotel.hotel_type === 'hotel' && !hotel.rates_fetched) {
      fetchRatesForHotel(state.meta.cache_id, hotel).then((response) => {
        dispatch({ type: SEARCH.RATES_FOR_HOTEL.SET, payload: response.data})
      })
    }

    //recheckHotelRates(state.searchBy, state, dispatch, hotel)
    _pushHistoryState(hotel)
  }

  const _pushHistoryState = (hotel) => {
    let newState = {...state}
    newState.hotels = []
    newState.currentHotels = []
    newState.visibleHotels = []
    newState.hotel = hotel
    newState.room = hotel.room_rates.rooms[0]
    newState.popUpOpen = true
    newState.arrival = state.arrival.format('YYYY-MM-DD')
    if (state.searchedArrival) {
      newState.searchedArrival = state.searchedArrival.format('YYYY-MM-DD')
    }

    window.history.pushState({
      all: newState,
      useExistingHotels: true
    }, 'Hotel Item Clicked', '/search')
  }

  let lowestRate = hotel.room_rates.rooms.map((rate) =>
    rate.rates[0]
  ).reduce((prev, curr) =>
    parseFloat(prev.net) < parseFloat(curr.net) ? prev : curr
  )

  let lowestPrice,
      feePrice = null

  if (userTypeSupportsSurcharge(state) && lowestRate.surcharge) {
    lowestPrice = `$${parseFloat(lowestRate.base)}`
    feePrice = lowestRate.surcharge
  } else {
    lowestPrice = `$${Math.ceil(hotel.room_rates.minRate)}`
  }

  const _handleFeeInfoClick = e => {
    e.stopPropagation()
    e.preventDefault()
    setShowFeeInfo(true)
  }

  const _handleCloseFeeInfo = e => {
    e.stopPropagation()
    e.preventDefault()
    setShowFeeInfo(false)
  }

  return (
    <li className={`row item ${state.hotel === hotel && 'active'} ${feePrice && 'exceeds'}`}>
      <button
        onClick={() => _clickHandler(hotel)}
        aria-label="Select Hotel"
        onMouseEnter={() => _setHotelHover(hotel.id)}
        onMouseLeave={() => _setHotelHover(null)}
        >
        <HotelImage hotel={hotel} isSearch />

        <div className="meta">
          <div className="top-content">
            <span className="title">{hotel.name}</span>

            <Rating count={hotel.rating} small={true} />

            {hotel.tags && hotel.tags.length > 0 && <HotelTags tags={hotel.tags} />}
          </div>

          {!isNotPriceApplicableUser(state.user) && (
            <div className="price">
              { !isMobileOnly && (
                <div className="number">
                  <em>Total for {`${state.searchedNights} ${state.searchedNights > 1 ? 'nights' : 'night'}`}</em>
                  <strong>{lowestPrice}{feePrice && <sup>*</sup>}</strong>
                </div>
                )
              }
              { isMobileOnly && (
                <React.Fragment>
                  <div className="number mobile">
                    <strong>{lowestPrice}{feePrice && <sup>*</sup>}</strong>
                    <em>for {`${state.searchedNights} ${state.searchedNights > 1 ? 'nights' : 'night'}`}</em>
                  </div>
                  <span
                    className="button plain view-deal-button small"
                    role="button"
                    >
                    View
                  </span>
                  </React.Fragment>
              )}
            </div>
          )}

          {feePrice &&
            <div className="price">
              <em className="fee">
                <sup>*</sup>Upgrade Fee -
                <i className="fas fa-info-circle" onClick={e => _handleFeeInfoClick(e)}></i></em>
              <em className="fee">+${Math.ceil(feePrice)}&nbsp;</em>
              <div className={`room-cap-info ${showFeeInfo && 'show'}`}>
                <i className="fas fa-times-circle" onClick={e => _handleCloseFeeInfo(e)}></i>
                <p>This upgrade fee applies because the total cost of the room exceeds your room cap.</p>
              </div>
            </div>
          }
        </div>
      </button>
    </li>
  )
}

HotelItem.propTypes = {
  hotel: MHotel.isRequired
}

export default HotelItem
